import { FormGroup } from "@angular/forms";
import { UserByUnitList } from "@app/models/profile.model";
import { CareConneRoomItem, UserByUnit } from "@app/models/user.model";

export interface SelectedRoomsState {
    [key: string]: {
        roomIds: number[];
    };
}

export interface SlideUpWindowByStudentState {
    filters: { name: string; isActive: boolean }[];
    searchUser: string;
    units: UserByUnitList[];
    selectedUnit: UserByUnitList | null;
    students: UserByUnit[];
    selectedUser: UserByUnit | null;
    allRoomData: CareConneRoomItem[];
    filteredRoomData: CareConneRoomItem[];
    selectedRoomIdsByUser: SelectedRoomsState;
    isInited: boolean;
    currentPage: number;
    isMessageOptional: boolean;
    form: FormGroup | null;
}

export const initialSlideUpWindowByStudentState: SlideUpWindowByStudentState = {
    filters: [],
    searchUser: '',
    units: [],
    selectedUnit: null,
    students: [],
    selectedUser: null,
    allRoomData: [],
    filteredRoomData: [],
    selectedRoomIdsByUser: {},
    isInited: false,
    currentPage: 0,
    isMessageOptional: false,
    form: null
};
